"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.mediaGenerator = void 0;
var _styledComponents = require("styled-components");
var _polished = require("polished");
var mediaGenerator = function mediaGenerator(theme, breakPoints, styles) {
  if (breakPoints === true) {
    // prettier-ignore
    return (0, _styledComponents.css)(["", ""], styles);
  }
  if (breakPoints && Array.isArray(breakPoints)) {
    // prettier-ignore
    return (0, _styledComponents.css)(["", " ", " ", " ", " ", ""], breakPoints.indexOf('xs') !== -1 && "\n        @media (max-width: ".concat((0, _polished.stripUnit)(theme.breakpoints.sm) - 1, "px) {\n          ").concat(styles, "\n        }\n      "), breakPoints.indexOf('sm') !== -1 && "\n        @media (min-width: ".concat(theme.breakpoints.sm, ") and (max-width: ").concat((0, _polished.stripUnit)(theme.breakpoints.md) - 1, "px) {\n          ").concat(styles, "\n        }\n      "), breakPoints.indexOf('md') !== -1 && "\n        @media (min-width: ".concat(theme.breakpoints.md, ") and (max-width: ").concat((0, _polished.stripUnit)(theme.breakpoints.lg) - 1, "px) {\n          ").concat(styles, "\n        }\n      "), breakPoints.indexOf('lg') !== -1 && "\n        @media (min-width: ".concat(theme.breakpoints.lg, ") and (max-width: ").concat((0, _polished.stripUnit)(theme.breakpoints.xl) - 1, "px) {\n          ").concat(styles, "\n        }\n      "), breakPoints.indexOf('xl') !== -1 && "\n        @media (min-width: ".concat(theme.breakpoints.xl, ") {\n          ").concat(styles, "\n        }\n      ")).join('');
  }
};
exports.mediaGenerator = mediaGenerator;
var _default = mediaGenerator;
exports.default = _default;